(() => {
  let lastDrawerTrigger = null;

  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`shopstar:${name}`, { detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
  };

  const closeDesktopMenus = (exceptToggle = null) => {
    document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach((toggle) => {
      if (toggle === exceptToggle) return;
      toggle.setAttribute('aria-expanded', 'false');
      document.getElementById(toggle.getAttribute('aria-controls'))?.setAttribute('hidden', '');
    });
  };

  document.addEventListener('click', (event) => {
    const openCart = event.target.closest('[data-cart-open]');
    const closeCart = event.target.closest('[data-cart-close]');
    const cartQuantity = event.target.closest('[data-cart-quantity]');
    const cartRemove = event.target.closest('[data-cart-remove]');
    const cartPageStep = event.target.closest('[data-cart-page-step]');
    const cartPageRemove = event.target.closest('[data-cart-page-remove]');
    const saveProduct = event.target.closest('[data-save-product]');
    const clearSaved = event.target.closest('[data-clear-saved-products]');
    const navToggle = event.target.closest('[data-nav-toggle]');
    const mobileSubmenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    const productQuantityStep = event.target.closest('[data-product-quantity-step]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (productQuantityStep) {
      event.preventDefault();
      const input = productQuantityStep.closest('.product-quantity')?.querySelector('[data-product-quantity-input]');
      if (!input) return;
      const current = Number.parseInt(input.value, 10);
      const stockLimit = Number(input.max) > 0 ? Number(input.max) : Infinity;   // never more than is in stock
      input.value = String(Math.min(stockLimit, Math.max(1, (Number.isFinite(current) ? current : 1) + Number(productQuantityStep.dataset.productQuantityStep))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (cartPageStep || cartPageRemove) {
      event.preventDefault();
      const line = (cartPageStep || cartPageRemove).closest('[data-cart-line]');
      const input = line?.querySelector('[data-cart-page-input]');
      if (!line || !input || line.closest('[data-cart-page]')?.dataset.cartPending === 'true') return;
      const currentQuantity = Number(input.value);
      const cartStockLimit = Number(input.max) > 0 ? Number(input.max) : Infinity;
      const nextQuantity = cartPageRemove ? 0 : Math.min(cartStockLimit, currentQuantity + Number(cartPageStep.dataset.cartPageStep));
      if (!cartPageRemove && nextQuantity === currentQuantity && Number(cartPageStep.dataset.cartPageStep) > 0) { validateCartQuantity(input); return; }
      if (input.value === '' || !Number.isSafeInteger(currentQuantity) || currentQuantity < 0 || !Number.isSafeInteger(nextQuantity) || nextQuantity < 0) {
        validateCartQuantity(input);
        return;
      }
      updateCartPage(line.dataset.lineKey, nextQuantity, {
        title: line.dataset.lineTitle || 'Item',
        action: cartPageRemove ? 'remove' : cartPageStep.dataset.cartPageStep
      });
      return;
    }
    if (navToggle) {
      event.preventDefault();
      const willOpen = navToggle.getAttribute('aria-expanded') !== 'true';
      closeDesktopMenus(navToggle);
      navToggle.setAttribute('aria-expanded', String(willOpen));
      document.getElementById(navToggle.getAttribute('aria-controls'))?.toggleAttribute('hidden', !willOpen);
    } else if (!event.target.closest('[data-desktop-nav]')) {
      closeDesktopMenus();
    }
    if (mobileSubmenuToggle) {
      event.preventDefault();
      const willOpen = mobileSubmenuToggle.getAttribute('aria-expanded') !== 'true';
      mobileSubmenuToggle.setAttribute('aria-expanded', String(willOpen));
      mobileSubmenuToggle.querySelector('[aria-hidden="true"]')?.replaceChildren(document.createTextNode(willOpen ? '−' : '+'));
      document.getElementById(mobileSubmenuToggle.getAttribute('aria-controls'))?.toggleAttribute('hidden', !willOpen);
    }
    if (openCart && drawer) {
      event.preventDefault();
      lastDrawerTrigger = openCart;
      drawer.setAttribute('open', '');
      document.body.classList.add('drawer-open');
      drawer.querySelector('[data-cart-close]')?.focus();
      emit('view_cart');
    }
    if (closeCart && drawer) {
      event.preventDefault();
      drawer.removeAttribute('open');
      document.body.classList.remove('drawer-open');
      lastDrawerTrigger?.focus();
    }
    if ((cartQuantity || cartRemove)?.closest('[data-cart-drawer]') && drawer) {
      event.preventDefault();
      updateCartFromUrl((cartQuantity || cartRemove).href);
    }
    if (saveProduct) {
      event.preventDefault();
      const product = getProductData(saveProduct);
      if (product) {
        const saved = toggleSavedProduct(product);
        renderSavedProducts();
        syncWishlistControls();
        announceWishlist(saved ? `${product.title} added to wishlist` : `${product.title} removed from wishlist`);
        emit('save_product', { item_name: product.title, item_url: product.url });
      }
    }
    if (clearSaved) {
      event.preventDefault();
      localStorage.removeItem('shopstar_saved_products');
      renderSavedProducts();
      syncWishlistControls();
      announceWishlist('Wishlist cleared');
    }

    const openMenu = event.target.closest('[data-menu-open]');
    const closeMenu = event.target.closest('[data-menu-close]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (openMenu && menu) {
      event.preventDefault();
      lastDrawerTrigger = openMenu;
      menu.setAttribute('open', '');
      document.body.classList.add('drawer-open');
      openMenu.setAttribute('aria-expanded', 'true');
      closeDesktopMenus();
      menu.querySelector('.mobile-nav__panel [data-menu-close]')?.focus();
    }
    if (closeMenu && menu) {
      event.preventDefault();
      menu.removeAttribute('open');
      document.body.classList.remove('drawer-open');
      document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
      lastDrawerTrigger?.focus();
    }

    const openFilters = event.target.closest('[data-filter-open]');
    const closeFilters = event.target.closest('[data-filter-close]');
    const filters = document.querySelector('#CollectionFilters');
    if (openFilters && filters) {
      event.preventDefault();
      lastDrawerTrigger = openFilters;
      filters.setAttribute('open', '');
      openFilters.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      filters.querySelector('[data-filter-close]')?.focus();
    }
    if (closeFilters && filters) {
      event.preventDefault();
      filters.removeAttribute('open');
      document.body.classList.remove('drawer-open');
      document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
      document.querySelector('[data-filter-open]')?.focus();
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-page] #CartNote')) {
      const noteInput = event.target;
      const cartPage = noteInput.closest('[data-cart-page]');
      fetch(`${cartPage.dataset.cartUrl}/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: noteInput.value })
      }).then((response) => {
        if (!response.ok) throw new Error('Order note could not be saved.');
        cartPage.querySelector('[data-cart-page-status]').textContent = 'Order note saved.';
      }).catch(() => {
        cartPage.querySelector('[data-cart-page-status]').textContent = 'Order note could not be saved. Please try again.';
      });
      return;
    }
    const input = event.target.closest('[data-cart-page-input]');
    if (!input || input.closest('[data-cart-page]')?.dataset.cartPending === 'true') return;
    if (!validateCartQuantity(input)) return;
    const quantity = Number(input.value);
    const line = input.closest('[data-cart-line]');
    updateCartPage(input.dataset.lineKey, quantity, {
      title: line?.dataset.lineTitle || 'Item',
      action: quantity === 0 ? 'remove' : 'input'
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      const openLayer = document.querySelector('[data-cart-drawer][open] .cart-drawer__panel, [data-mobile-menu][open] .mobile-nav__panel, #CollectionFilters[open]');
      if (openLayer) {
        const focusable = [...openLayer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && (document.activeElement === first || !openLayer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !openLayer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        }
      }
    }
    if (event.key !== 'Escape') return;
    const expandedNavToggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
    if (expandedNavToggle) {
      closeDesktopMenus();
      expandedNavToggle.focus();
      return;
    }
    document.querySelector('[data-cart-drawer][open]')?.removeAttribute('open');
    document.querySelector('[data-mobile-menu][open]')?.removeAttribute('open');
    document.querySelector('#CollectionFilters[open]')?.removeAttribute('open');
    document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
    document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    lastDrawerTrigger?.focus();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-ajax-cart-form]')) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Cart add failed');
      const item = await response.json();
      emit('add_to_cart', { item_id: item.id, product_id: item.product_id, quantity: item.quantity });
      await refreshCartDrawer();
      const drawer = document.querySelector('[data-cart-drawer]');
      drawer?.setAttribute('open', '');
      document.body.classList.toggle('drawer-open', Boolean(drawer));
    } catch (error) {
      form.submit();
    } finally {
      submit?.removeAttribute('aria-busy');
    }
  });

  async function refreshCartDrawer() {
    const drawerBody = document.querySelector('[data-cart-items]');
    const countEls = document.querySelectorAll('[data-cart-count]');
    const drawerFooter = document.querySelector('[data-cart-footer]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (!drawerBody) return;
    const [cart, stock] = await Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
      fetch('/cart?view=stock').then((r) => r.json()).catch(() => ({})),   // what is in stock for each line (0 or missing: no limit known)
    ]);
    countEls.forEach((el) => { el.textContent = cart.item_count; });
    if (subtotal) subtotal.textContent = formatCartMoney(cart.total_price, cart.currency);
    drawerFooter?.toggleAttribute('hidden', cart.item_count === 0);
    drawerBody.innerHTML = cart.items.map((item) => `
      <div class="cart-item">
        ${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<div></div>'}
        <div>
          <a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
          <div class="muted">${escapeHTML(item.variant_title || '')}</div>
          <div>${formatCartMoney(item.final_line_price, cart.currency)}</div>
          <div class="cart-quantity" aria-label="${escapeHTML(window.themeStrings?.quantity || 'Quantity')}">
            <a class="icon-button" href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=${Math.max(item.quantity - 1, 0)}" data-cart-quantity aria-label="${escapeHTML(window.themeStrings?.decreaseQuantity || 'Decrease quantity')}">&minus;</a>
            <span>${item.quantity}</span>
            ${Number(stock[item.variant_id]) > 0 && item.quantity >= Number(stock[item.variant_id])
              ? `<span class="icon-button is-disabled" aria-disabled="true" title="Only ${Number(stock[item.variant_id])} available">+</span>`
              : `<a class="icon-button" href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=${item.quantity + 1}" data-cart-quantity aria-label="${escapeHTML(window.themeStrings?.increaseQuantity || 'Increase quantity')}">+</a>`}
          </div>
          ${Number(stock[item.variant_id]) > 0 ? `<div class="muted cart-item__limit">${item.quantity >= Number(stock[item.variant_id]) ? 'Only ' : ''}${Number(stock[item.variant_id])} available</div>` : ''}
          <a class="cart-item__remove" href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0" data-cart-remove>${escapeHTML(window.themeStrings?.remove || 'Remove')}</a>
        </div>
        <a href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0" data-cart-remove aria-label="${escapeHTML(window.themeStrings?.remove || 'Remove')}">&times;</a>
      </div>
    `).join('') || `<p>${window.themeStrings?.cartEmpty || 'Your cart is empty'}</p>`;
  }

  async function updateCartFromUrl(url) {
    try {
      await fetch(url, { headers: { Accept: 'application/json' } });
      await refreshCartDrawer();
      emit('update_cart');
    } catch (error) {
      window.location.href = url;
    }
  }

  function validateCartQuantity(input) {
    const quantity = Number(input.value);
    const stockMax = Number(input.max) > 0 ? Number(input.max) : Infinity;
    const valid = input.value !== '' && Number.isSafeInteger(quantity) && quantity >= 0 && quantity <= stockMax;
    input.setCustomValidity(valid ? '' : (quantity > stockMax ? `Only ${stockMax} available.` : 'Enter a whole number of zero or more.'));
    if (!valid) input.reportValidity();
    return valid;
  }

  function setCartPagePending(page, pending) {
    page.dataset.cartPending = String(pending);
    page.querySelector('[data-cart-page-form]')?.setAttribute('aria-busy', String(pending));
    page.querySelectorAll('button, input, textarea').forEach((control) => { control.disabled = pending; });
    page.querySelectorAll('[data-cart-page-remove]').forEach((link) => {
      if (pending) link.setAttribute('aria-disabled', 'true'); else link.removeAttribute('aria-disabled');
      if (pending) link.setAttribute('tabindex', '-1'); else link.removeAttribute('tabindex');
    });
  }

  async function updateCartPage(lineKey, quantity, context = {}) {
    const page = document.querySelector('[data-cart-page]');
    if (!page || page.dataset.cartPending === 'true') return;
    const status = page.querySelector('[data-cart-page-status]');
    const note = page.querySelector('#CartNote')?.value || '';
    const changeRoute = `${page.dataset.cartChangeUrl || '/cart/change'}`.replace(/\.js$/, '').replace(/\/$/, '') + '.js';
    const cartRoute = page.dataset.cartUrl || '/cart';
    page.querySelector('[data-cart-page-error]')?.setAttribute('hidden', '');
    setCartPagePending(page, true);
    if (status) status.textContent = `Updating ${context.title || 'item'}.`;
    try {
      const response = await fetch(changeRoute, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Cart update failed');
      const htmlResponse = await fetch(cartRoute, { headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      if (!htmlResponse.ok) throw new Error('Cart refresh failed');
      const nextDocument = new DOMParser().parseFromString(await htmlResponse.text(), 'text/html');
      const nextPage = nextDocument.querySelector('[data-cart-page]');
      if (!nextPage) throw new Error('Cart refresh failed');
      nextPage.querySelectorAll('noscript').forEach((fallback) => fallback.remove());
      const nextNote = nextPage.querySelector('#CartNote');
      if (nextNote) nextNote.value = note;
      page.replaceWith(nextPage);
      document.dispatchEvent(new CustomEvent('shopstar:cart_page_replaced'));
      document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = String(cart.item_count); });
      const actualItem = cart.items.find((item) => item.key === lineKey);
      const actualQuantity = actualItem?.quantity || 0;
      const removed = actualQuantity === 0;
      const message = removed
        ? `${context.title || 'Item'} removed from cart. ${cart.item_count} item${cart.item_count === 1 ? '' : 's'} in cart.`
        : `${context.title || 'Item'} quantity updated to ${actualQuantity}. Cart total ${formatCartMoney(cart.total_price, cart.currency)}.`;
      const nextStatus = nextPage.querySelector('[data-cart-page-status]');
      if (nextStatus) nextStatus.textContent = message;
      if (document.querySelector('[data-cart-drawer]')) await refreshCartDrawer();
      emit('update_cart', { item_key: lineKey, quantity, item_count: cart.item_count, value: cart.total_price / 100, currency: cart.currency });
      window.setTimeout(() => {
        if (removed) {
          nextPage.querySelector('[data-cart-page-step], a, button')?.focus();
          return;
        }
        const nextLine = [...nextPage.querySelectorAll('[data-cart-line]')].find((candidate) => candidate.dataset.lineKey === lineKey);
        const selector = context.action === '-1' ? '[data-cart-page-step="-1"]' : context.action === '1' ? '[data-cart-page-step="1"]' : '[data-cart-page-input]';
        nextLine?.querySelector(selector)?.focus();
      }, 0);
    } catch (error) {
      if (document.contains(page)) {
        setCartPagePending(page, false);
        if (status) status.textContent = error.message || 'The cart could not be updated. Please try again.';
        const errorMessage = page.querySelector('[data-cart-page-error]');
        if (errorMessage) {
          errorMessage.textContent = error.message || 'The cart could not be updated. Please try again.';
          errorMessage.hidden = false;
        }
      }
    }
  }

  function formatCartMoney(cents, currency) {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
  }

  document.querySelectorAll('[data-predictive-search]').forEach((container) => {
    const input = container.querySelector('input[type="search"]');
    const results = container.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    let controller;
    input.addEventListener('input', async () => {
      const q = input.value.trim();
      if (q.length < 2) {
        results.removeAttribute('open');
        results.innerHTML = '';
        return;
      }
      controller?.abort();
      controller = new AbortController();
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=${container.dataset.limit || 6}`;
        const data = await fetch(url, { signal: controller.signal }).then((r) => r.json());
        const products = data.resources.results.products || [];
        const collections = data.resources.results.collections || [];
        const articles = data.resources.results.articles || [];
        results.innerHTML = `<ul>${[...products, ...collections, ...articles].map((item) => `
          <li><a href="${escapeHTML(item.url)}">
            ${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<span></span>'}
            <span><strong>${escapeHTML(item.title)}</strong>${item.price ? `<small class="muted">${escapeHTML(item.price)}</small>` : ''}</span>
          </a></li>`).join('')}</ul>`;
        results.toggleAttribute('open', products.length + collections.length + articles.length > 0);
        emit('search', { search_term: q, predictive: true });
      } catch (error) {
        if (error.name !== 'AbortError') results.removeAttribute('open');
      }
    });
  });

  document.querySelectorAll('[data-desktop-nav] .nav__item').forEach((item) => {
    const toggle = item.querySelector('[data-nav-toggle]');
    const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
      closeDesktopMenus(toggle);
      toggle?.setAttribute('aria-expanded', 'true');
      panel?.removeAttribute('hidden');
    });
    item.addEventListener('pointerleave', () => {
      if (item.contains(document.activeElement)) return;
      toggle?.setAttribute('aria-expanded', 'false');
      panel?.setAttribute('hidden', '');
    });
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      const toggle = item.querySelector('[data-nav-toggle]');
      if (!toggle) return;
      toggle.setAttribute('aria-expanded', 'false');
      document.getElementById(toggle.getAttribute('aria-controls'))?.setAttribute('hidden', '');
    });
  });

  // Announcement bar: copy the promo code (with a quiet fallback where the clipboard API is not allowed).
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;
    const code = button.dataset.copyCode;
    let copied = false;
    try { await navigator.clipboard.writeText(code); copied = true; } catch (error) {
      const field = document.createElement('textarea');
      field.value = code; field.setAttribute('readonly', ''); field.style.position = 'fixed'; field.style.opacity = '0';
      document.body.appendChild(field); field.select();
      try { copied = document.execCommand('copy'); } catch (inner) { copied = false; }
      field.remove();
    }
    const status = button.parentElement?.querySelector('[data-copy-status]');
    if (copied && status) status.textContent = button.dataset.copiedText || '';
    if (copied) { const original = button.textContent; button.textContent = button.dataset.copiedText || original; setTimeout(() => { button.textContent = original; }, 2000); }
  });

  document.querySelectorAll('[data-product-form-scope]').forEach((scope) => {
    const json = scope.querySelector('[data-product-json]');
    const variantInputs = [...scope.querySelectorAll('[data-variant-input]')];
    if (!json || !variantInputs.length) return;
    const product = JSON.parse(json.textContent);
    const radios = [...scope.querySelectorAll('[data-option-radio]')];
    const updateVariant = () => {
      const selected = [];
      radios.forEach((radio) => {
        if (radio.checked) selected[Number(radio.dataset.optionPosition) - 1] = radio.value;
      });
      const variant = product.variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (variant) {
        variantInputs.forEach((input) => { input.value = variant.id; });
        scope.dataset.productVariantId = String(variant.id);
        scope.dataset.productAvailable = String(Boolean(variant.available));
        scope.querySelectorAll('[data-product-submit]').forEach((button) => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
        });
        const state = scope.querySelector(`[data-variant-state="${CSS.escape(String(variant.id))}"]`)?.content;
        const stock = scope.querySelector('[data-product-stock-status]');
        const badges = scope.querySelector('[data-product-badges]');
        if (stock && state) stock.replaceChildren(...state.querySelector('[data-state-stock]').cloneNode(true).childNodes);
        if (badges && state) badges.replaceChildren(...state.querySelector('[data-state-badges]').cloneNode(true).childNodes);
        const variantUrl = new URL(location.href);
        variantUrl.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', variantUrl);
        variantInputs.forEach((input) => { input.disabled = !variant.available; });
        const currency = window.Shopify?.currency?.active || 'AUD';
        const price = formatCartMoney(Number(variant.price || 0), currency);
        const compareAt = Number(variant.compare_at_price || 0);
        const livePrice = scope.querySelector('[data-product-live-price] [data-price]');
        if (livePrice) {
          livePrice.innerHTML = compareAt > Number(variant.price)
            ? `<span class="visually-hidden">Sale price</span><span class="price__sale">${escapeHTML(price)}</span><span class="visually-hidden">Regular price</span><span class="price__compare">${escapeHTML(formatCartMoney(compareAt, currency))}</span>`
            : `<span>${escapeHTML(price)}</span>`;
        }
        scope.querySelector('[data-product-sticky-price]')?.replaceChildren(document.createTextNode(price));
        scope.dispatchEvent(new CustomEvent('shopstar:variant_change', { bubbles: true, detail: { variant } }));
      } else {
        variantInputs.forEach((input) => { input.disabled = true; input.value = ''; });
        scope.dataset.productAvailable = 'false';
        scope.querySelectorAll('[data-product-submit]').forEach((button) => { button.disabled = true; button.textContent = button.dataset.soldText; });
        scope.querySelector('[data-product-badges]')?.replaceChildren();
        scope.querySelector('[data-product-stock-status]')?.replaceChildren(document.createTextNode(window.themeStrings?.variantUnavailable || 'This combination is unavailable'));
      }
    };
    radios.forEach((radio) => radio.addEventListener('change', updateVariant));
    scope.querySelectorAll('[data-product-quantity-input]').forEach((input) => input.addEventListener('change', () => {
      const quantity = Number.parseInt(input.value, 10);
      input.value = String(Number.isSafeInteger(quantity) && quantity >= 1 ? quantity : 1);
    }));
  });

  const productMarker = document.querySelector('[data-recent-product]');
  if (productMarker) {
    const product = {
      title: productMarker.dataset.title,
      url: productMarker.dataset.url,
      image: productMarker.dataset.image,
      price: productMarker.dataset.price,
      compare: productMarker.dataset.compare,
      off: productMarker.dataset.off
    };
    const key = 'shopstar_recent_products';
    const recent = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.url !== product.url);
    localStorage.setItem(key, JSON.stringify([product, ...recent].slice(0, 16)));
  }

  document.querySelectorAll('[data-recently-viewed]').forEach((container) => {
    const recent = JSON.parse(localStorage.getItem('shopstar_recent_products') || '[]');
    if (!recent.length) {
      // Nothing viewed yet (a new visitor, or cleared browser data): show the popular products instead, so the row is never an empty gap.
      const fallback = container.closest('[data-recently-viewed-section]')?.querySelector('template[data-recent-fallback]');
      if (fallback) {
        container.innerHTML = fallback.innerHTML;
        const heading = container.closest('[data-recently-viewed-section]').querySelector('[data-recent-heading]');
        if (heading?.dataset.fallbackHeading) heading.textContent = heading.dataset.fallbackHeading;
        container.closest('[data-recently-viewed-section]').removeAttribute('hidden');
      }
      return;
    }
    const limit = Math.min(16, Math.max(1, Number(container.dataset.recentlyViewedLimit || 16)));
    container.innerHTML = renderStoredProductCards(recent.slice(0, limit));
    // Products stored before compare-at prices were kept have none: look each up once (the product's own .js address) and keep the answer.
    const unchecked = recent.slice(0, limit).filter((item) => !item.checked && item.url);
    if (unchecked.length) {
      Promise.all(unchecked.map((item) => fetch(item.url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null)).catch(() => null)
        .then((data) => {
          if (!data) return;
          item.checked = true;
          if (data.compare_at_price > data.price) {
            const money = (cents) => '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            item.price = money(data.price);
            item.compare = money(data.compare_at_price);
            item.off = String(Math.floor((data.compare_at_price - data.price) * 100 / data.compare_at_price));
          }
        }))).then(() => {
        try { localStorage.setItem('shopstar_recent_products', JSON.stringify(recent)); } catch (error) { /* private mode */ }
        container.innerHTML = renderStoredProductCards(recent.slice(0, limit));
      });
    }
    const section = container.closest('[data-recently-viewed-section]');
    const viewport = container.closest('[data-recently-viewed-viewport]');
    const previous = viewport?.querySelector('[data-recently-viewed-previous]');
    const next = viewport?.querySelector('[data-recently-viewed-next]');
    let scrollFrame = null;
    const updateControls = () => {
      const maximum = Math.max(0, container.scrollWidth - container.clientWidth);
      const canScroll = maximum > 1;
      if (viewport) viewport.dataset.canScroll = String(canScroll);
      if (previous) previous.disabled = !canScroll || container.scrollLeft <= 4;
      if (next) next.disabled = !canScroll || container.scrollLeft >= maximum - 4;
    };
    const move = (direction) => {
      container.scrollBy({ left: direction * container.clientWidth, behavior: 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    container.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(updateControls);
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(updateControls).observe(container);
    section?.removeAttribute('hidden');
    requestAnimationFrame(updateControls);
  });

  function renderStoredProductCards(items) {
    return items.map((item) => `
      <article class="product-card product-card--stored">
        <a class="product-card__media" href="${escapeHTML(item.url)}" aria-label="${escapeHTML(item.title)}">${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<span></span>'}</a>
        <div class="product-card__body">
          <a class="product-card__title" href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a>
          ${item.price ? (item.compare ? `<div class="price"><span class="price__sale">${escapeHTML(item.price)}</span><span class="price__compare">${escapeHTML(item.compare)}</span>${item.off ? `<span class="badge badge--sale">${escapeHTML(item.off)}% off</span>` : ''}</div>` : `<div class="price"><span>${escapeHTML(item.price)}</span></div>`) : ''}
        </div>
      </article>
    `).join('');
  }

  renderSavedProducts();
  syncWishlistControls();

  function getProductData(trigger) {
    const card = trigger.closest('[data-product-card]');
    if (!card?.dataset.productUrl) return null;
    return {
      title: card.dataset.productTitle || '',
      url: card.dataset.productUrl,
      image: card.dataset.productImage || '',
      price: card.dataset.productPrice || '',
      variantId: card.dataset.productVariantId || '',
      available: card.dataset.productAvailable !== 'false'
    };
  }

  function toggleSavedProduct(product) {
    const key = 'shopstar_saved_products';
    const items = readStoredProducts(key);
    const exists = items.some((item) => item.url === product.url);
    const next = exists
      ? items.filter((item) => item.url !== product.url)
      : [product, ...items.filter((item) => item.url !== product.url)].slice(0, 12);
    localStorage.setItem(key, JSON.stringify(next));
    return !exists;
  }

  function readStoredProducts(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item?.url);
    } catch (error) {
      return [];
    }
  }

  function updateWishlistCount() {
    const count = readStoredProducts('shopstar_saved_products').length;
    document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
      link.classList.toggle('has-items', count > 0);
      link.classList.toggle('is-saved', count > 0);
      link.setAttribute('aria-label', count > 0 ? `Wishlist, ${count} saved product${count === 1 ? '' : 's'}` : 'Wishlist');
    });
  }

  function announceWishlist(message) {
    document.querySelectorAll('[data-wishlist-status]').forEach((status) => { status.textContent = message; });
  }

  async function renderSavedProducts() {
    const containers = [...document.querySelectorAll('[data-saved-products]')];
    const items = readStoredProducts('shopstar_saved_products');
    updateWishlistCount();
    containers.forEach((container) => {
      const section = container.closest('[data-saved-products-section]');
      section?.querySelector('[data-saved-products-count]')?.replaceChildren(document.createTextNode(`${items.length} saved product${items.length === 1 ? '' : 's'}`));
      section?.querySelector('[data-saved-products-empty]')?.toggleAttribute('hidden', items.length > 0);
      section?.querySelector('[data-clear-saved-products]')?.toggleAttribute('hidden', items.length === 0);
      container.innerHTML = items.length ? '<p class="muted">Checking current product availability…</p>' : '';
    });
    if (!containers.length || !items.length) return;
    const products = await Promise.all(items.map(async (stored) => {
      try {
        const response = await fetch(`${stored.url}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unavailable');
        const product = await response.json();
        const variants = product.variants || [];
        const availableVariant = variants.find((entry) => entry.available);
        const singleDefaultVariant = variants.length === 1 && variants[0]?.title === 'Default Title';
        return {
          ...stored,
          title: product.title || stored.title,
          image: product.featured_image || stored.image,
          price: availableVariant ? formatCartMoney(Number(availableVariant.price || 0), window.Shopify?.currency?.active || 'AUD') : stored.price,
          variantId: singleDefaultVariant && availableVariant ? availableVariant.id : '',
          available: Boolean(availableVariant),
          requiresSelection: variants.length > 1,
          stale: false
        };
      } catch (error) {
        return { ...stored, stale: true, available: false, variantId: '' };
      }
    }));
    containers.forEach((container) => { container.innerHTML = renderSavedProductCards(products); });
    syncWishlistControls();
  }

  function renderSavedProductCards(items) {
    return items.map((item) => `
      <article class="product-card product-card--stored" data-product-card data-product-title="${escapeHTML(item.title)}" data-product-url="${escapeHTML(item.url)}" data-product-image="${escapeHTML(item.image || '')}" data-product-price="${escapeHTML(item.price || '')}" data-product-variant-id="${escapeHTML(item.variantId || '')}" data-product-available="${item.available}">
        <a class="product-card__media" href="${escapeHTML(item.url)}" aria-label="${escapeHTML(item.title)}">${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<span></span>'}</a>
        <button class="wishlist-button is-saved" type="button" data-save-product aria-pressed="true" aria-label="Remove ${escapeHTML(item.title)} from wishlist">${heartIcon()}</button>
        <div class="product-card__body">
          <a class="product-card__title" href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a>
          ${item.price ? (item.compare ? `<div class="price"><span class="price__sale">${escapeHTML(item.price)}</span><span class="price__compare">${escapeHTML(item.compare)}</span>${item.off ? `<span class="badge badge--sale">${escapeHTML(item.off)}% off</span>` : ''}</div>` : `<div class="price"><span>${escapeHTML(item.price)}</span></div>`) : ''}
          ${item.stale ? '<p class="muted">This product is no longer available. You can remove it from your wishlist.</p>' : `<span class="badge ${item.available ? 'badge--stock' : 'badge--out-of-stock'}">${item.available ? 'In stock' : 'Out of stock'}</span>${item.available && item.variantId ? `<form method="post" action="/cart/add" data-ajax-cart-form><input type="hidden" name="id" value="${escapeHTML(item.variantId)}"><button class="button button--full" type="submit">Add to cart</button></form>` : (item.available && item.requiresSelection ? `<a class="button button--secondary button--full" href="${escapeHTML(item.url)}">Choose options</a>` : '<p class="muted">Currently unavailable</p>')}`}
          <a class="button button--secondary button--full" href="${escapeHTML(item.url)}">${escapeHTML(window.themeStrings?.viewProduct || 'View product')}</a>
        </div>
      </article>
    `).join('');
  }

  function heartIcon() {
    return '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20.8 4.7a5.6 5.6 0 0 0-7.9 0L12 5.6l-.9-.9a5.6 5.6 0 0 0-7.9 7.9l.9.9L12 21.4l7.9-7.9.9-.9a5.6 5.6 0 0 0 0-7.9Z"/></svg>';
  }

  function syncWishlistControls() {
    const saved = readStoredProducts('shopstar_saved_products');
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const url = card.dataset.productUrl;
      if (!url) return;
      const saveButton = card.querySelector('[data-save-product]');
      if (saveButton) {
        const isSaved = saved.some((item) => item.url === url);
        saveButton.classList.toggle('is-saved', isSaved);
        saveButton.setAttribute('aria-pressed', String(isSaved));
        saveButton.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Save'} ${card.dataset.productTitle || 'product'} ${isSaved ? 'from' : 'to'} wishlist`);
        const label = saveButton.querySelector('span');
        if (label) label.textContent = isSaved ? 'Saved to wishlist' : 'Save to wishlist';
        const tooltip = saveButton.closest('.product-wishlist-control')?.querySelector('[role="tooltip"]');
        if (tooltip) tooltip.textContent = isSaved ? 'Remove from wishlist' : 'Save to wishlist';
      }
    });
    updateWishlistCount();
  }
  const bedroomBuilderQuery = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-bedroom-builder]').forEach((builder) => {
    const immersiveMode = bedroomBuilderQuery.get('bedroom-builder') === '1';
    if (immersiveMode) {
      document.body.classList.add('bedroom-builder-mode');
      (builder.closest('.shopify-section') || builder).classList.add('bedroom-builder-host');
    }
    const panels = [...builder.querySelectorAll('[data-builder-panel]')];
    const progressButtons = [...builder.querySelectorAll('[data-builder-progress-step]')];
    progressButtons.forEach((button, index) => button.setAttribute('aria-label', `Step ${index + 1}: ${button.dataset.builderStepLabel || button.textContent.trim()}`));
    const storageKey = `shopstar_bedroom_builder_${builder.dataset.builderStorageKey || 'default'}`;
    const defaultState = { size: '', sizeLabel: '', items: [] };
    let state = defaultState;
    let activeStep = 0;

    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (stored && Array.isArray(stored.items)) state = { ...defaultState, ...stored };
    } catch (error) { state = defaultState; }

    const requestedSize = bedroomBuilderQuery.get('size');
    const requestedSizeButton = requestedSize && builder.querySelector(`[data-builder-size][data-size-value="${CSS.escape(requestedSize)}"]`);
    if (requestedSizeButton) {
      state.size = requestedSizeButton.dataset.sizeValue || '';
      state.sizeLabel = requestedSizeButton.dataset.sizeLabel || '';
    }
    const requestedStartStep = immersiveMode ? 1 : Number(builder.dataset.builderStartStep || 0);
    activeStep = state.size ? Math.max(0, Math.min(requestedStartStep, panels.length - 1)) : 0;

    const currentVariant = (card) => card.querySelector('[data-builder-variant]')?.value || '';
    const variantOption = (card) => card.querySelector('[data-builder-variant] option:checked');
    const currentVariantPrice = (card) => variantOption(card)?.dataset.variantPrice || card.querySelector('[data-builder-variant]')?.dataset.variantPrice || '0';
    const normalizeSize = (value) => String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
    const detectProductSizes = (value) => {
      let normalized = normalizeSize(value);
      const detected = [];
      ['super-king', 'king-single'].forEach((specialSize) => {
        if (normalized.includes(specialSize)) detected.push(specialSize);
        normalized = normalized.replaceAll(specialSize, '');
      });
      ['single', 'double', 'queen', 'king'].forEach((size) => {
        if (`-${normalized}-`.includes(`-${size}-`)) detected.push(size);
      });
      return [...new Set(detected)];
    };
    const cardKey = (card) => `${card.dataset.stepKey}:${card.dataset.productId}`;
    const selectedForCard = (card) => state.items.find((item) => item.cardKey === cardKey(card));
    const visibleForSize = (card) => {
      if ((card.dataset.sizeValues || '').includes('all-sizes')) return true;
      const availableSizes = detectProductSizes(card.dataset.sizeValues || '');
      return !state.size || availableSizes.includes(state.size);
    };
    const saveState = () => {
      try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) { /* Storage is optional. */ }
    };
    const syncCardAvailability = (card) => {
      const select = card.querySelector('[data-builder-variant]');
      const button = card.querySelector('[data-builder-select]');
      const option = variantOption(card);
      if (button) button.disabled = Boolean(option?.disabled || !currentVariant(card));
      if (select) select.setAttribute('aria-label', `Choose an option for ${card.dataset.productTitle || 'this item'}`);
    };
    const applyPanelFilters = (panel) => {
      const products = panel.querySelector('[data-builder-products]');
      if (!products) return;
      const cards = [...products.querySelectorAll('[data-builder-item]')];
      const availability = panel.querySelector('[data-builder-filter="availability"]')?.value || '';
      const minPrice = Number(panel.querySelector('[data-builder-filter="min-price"]')?.value || 0);
      const maxPriceValue = panel.querySelector('[data-builder-filter="max-price"]')?.value || '';
      const maxPrice = maxPriceValue === '' ? Infinity : Number(maxPriceValue);
      const sort = panel.querySelector('[data-builder-sort]')?.value || 'featured';
      // Each facet reads a card's own attributes; "feature" is a list (a bed can have storage and lights), the others one value.
      const facets = [
        { key: 'type', attr: 'productType', label: 'typeLabel' },
        { key: 'material', attr: 'productMaterial', label: 'materialLabel' },
        { key: 'colour', attr: 'productColour', label: 'colourLabel' },
        { key: 'mattresstype', attr: 'productMattresstype', label: 'mattresstypeLabel' },
        { key: 'firmness', attr: 'productFirmness', label: 'firmnessLabel' },
        { key: 'frame', attr: 'productFrame', label: 'frameLabel' },
        { key: 'feature', attr: 'productFeature', multi: true },
      ];
      const chosen = {};
      facets.forEach((facet) => { chosen[facet.key] = panel.querySelector(`[data-builder-filter="${facet.key}"]`)?.value || ''; });
      const valuesOf = (card, facet) => facet.multi
        ? (card.dataset[facet.attr] || '').split('|').filter(Boolean).map((label) => ({ value: label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''), label }))
        : (card.dataset[facet.attr] ? [{ value: card.dataset[facet.attr], label: card.dataset[facet.label] || card.dataset[facet.attr] }] : []);
      const passes = (card, skip) => visibleForSize(card)
        && facets.every((facet) => facet.key === skip || !chosen[facet.key] || valuesOf(card, facet).some((v) => v.value === chosen[facet.key]))
        && (!availability || card.dataset.productAvailable === availability)
        && (Number(card.dataset.productPrice || 0) / 100) >= minPrice && (Number(card.dataset.productPrice || 0) / 100) <= maxPrice;
      // The choices come from the products themselves; each shows how many products it would leave given the other choices, and a choice that
      // would leave none is greyed out. A facet no product in the step has is hidden.
      facets.forEach((facet) => {
        const select = panel.querySelector(`[data-builder-filter="${facet.key}"]`);
        if (!select) return;
        const found = new Map();
        cards.forEach((card) => {
          const ok = passes(card, facet.key);
          valuesOf(card, facet).forEach(({ value, label }) => {
            const entry = found.get(value) || { label, count: 0 };
            if (ok) entry.count += 1;
            found.set(value, entry);
          });
        });
        const current = select.value;
        const first = select.querySelector('option');
        select.replaceChildren(first);
        [...found.entries()].sort((a, b) => a[1].label.localeCompare(b[1].label)).forEach(([value, entry]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = `${entry.label} (${entry.count})`;
          option.disabled = entry.count === 0 && value !== current;
          select.appendChild(option);
        });
        if (found.has(current)) select.value = current;
        select.closest('label')?.toggleAttribute('hidden', found.size === 0);
        chosen[facet.key] = select.value;
      });
      const anyChosen = facets.some((facet) => chosen[facet.key]) || availability || minPrice > 0 || maxPriceValue !== '';
      panel.querySelector('[data-builder-clear-filters]')?.toggleAttribute('hidden', !anyChosen);
      cards.forEach((card, index) => {
        if (!card.dataset.sourceIndex) card.dataset.sourceIndex = String(index);
        card.hidden = !passes(card, '');
      });
      cards.sort((a, b) => {
        if (sort === 'price-asc' || sort === 'price-desc') {
          const difference = Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
          return sort === 'price-asc' ? difference : -difference;
        }
        if (sort === 'title-asc') return (a.dataset.productTitle || '').localeCompare(b.dataset.productTitle || '');
        return Number(a.dataset.sourceIndex) - Number(b.dataset.sourceIndex);
      }).forEach((card) => products.appendChild(card));
      const visibleCards = cards.filter((card) => !card.hidden);
      panel.querySelector('[data-builder-no-match]')?.toggleAttribute('hidden', visibleCards.length > 0);
      const resultCount = panel.querySelector('[data-builder-result-count]');
      if (resultCount) {
        const sizeLabel = state.sizeLabel ? ` for ${state.sizeLabel}` : '';
        resultCount.textContent = `${visibleCards.length} product${visibleCards.length === 1 ? '' : 's'}${sizeLabel}`;
      }
    };
    const previewDialog = builder.querySelector('[data-builder-preview-dialog]');
    const previewContent = builder.querySelector('[data-builder-preview-content]');
    const previewCache = new Map();
    const closeProductPreview = () => {
      if (previewDialog?.open) previewDialog.close();
    };
    const openProductPreview = async (card) => {
      if (!previewDialog || !previewContent || !card) return;
      const productUrl = card.dataset.productUrl || '';
      const handle = productUrl.match(/\/products\/([^?]+)/)?.[1];
      if (!handle) return;
      previewContent.innerHTML = '<div class="bedroom-builder__preview-copy"><p>Loading product details...</p></div>';
      if (!previewDialog.open) previewDialog.showModal();
      try {
        let product = previewCache.get(handle);
        if (!product) {
          product = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
            if (!response.ok) throw new Error('Product preview request failed');
            return response.json();
          });
          previewCache.set(handle, product);
        }
        const previewVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0];
        const previewPrice = previewVariant ? formatCartMoney(Number(previewVariant.price || 0), window.Shopify?.currency?.active || 'AUD') : '';
        const previewImages = Array.isArray(product.images) && product.images.length
          ? product.images
          : (product.featured_image ? [product.featured_image] : []);
        const description = String(product.description || '').trim();
        const sized = (image, width) => `${String(image).replace(/^http:/, 'https:')}${String(image).includes('?') ? '&' : '?'}width=${width}`;
        const title = product.title || card.dataset.productTitle || '';
        previewContent.innerHTML = `<div class="bedroom-builder__preview-content">
          <div class="bedroom-builder__preview-heading">
            <h3>${escapeHTML(title)}</h3>
            ${previewPrice ? `<div class="price"><span>${escapeHTML(previewPrice)}</span></div>` : ''}
          </div>
          ${previewImages.length ? `<div class="bedroom-builder__carousel" data-preview-carousel>
            <div class="bedroom-builder__carousel-stage">
              ${previewImages.length > 1 ? '<button class="bedroom-builder__carousel-step bedroom-builder__carousel-step--prev" type="button" data-preview-step="-1" aria-label="Previous picture">&#8249;</button>' : ''}
              <img src="${escapeHTML(sized(previewImages[0], 1200))}" alt="${escapeHTML(title)}" data-preview-main>
              ${previewImages.length > 1 ? '<button class="bedroom-builder__carousel-step bedroom-builder__carousel-step--next" type="button" data-preview-step="1" aria-label="Next picture">&#8250;</button>' : ''}
            </div>
            ${previewImages.length > 1 ? `<div class="bedroom-builder__carousel-thumbs">${previewImages.map((image, index) => `<button type="button" data-preview-thumb="${index}" aria-label="Picture ${index + 1}" aria-current="${index === 0}"><img src="${escapeHTML(sized(image, 160))}" alt="" loading="lazy"></button>`).join('')}</div>` : ''}
          </div>` : '<div class="bedroom-builder__product-placeholder" aria-hidden="true"></div>'}
          ${description ? `<div class="bedroom-builder__preview-description rte">${description}</div>` : ''}
          <div class="bedroom-builder__preview-footer">
            <a class="button button--secondary" href="${escapeHTML(productUrl)}" target="_blank" rel="noopener">Open in new tab</a>
            <button class="button" type="button" data-builder-preview-choose data-preview-product-id="${escapeHTML(card.dataset.productId)}">Choose options in builder</button>
          </div>
        </div>`;
        const carousel = previewContent.querySelector('[data-preview-carousel]');
        if (carousel) {
          let at = 0;
          const main = carousel.querySelector('[data-preview-main]');
          const go = (index) => {
            at = (index + previewImages.length) % previewImages.length;
            main.src = sized(previewImages[at], 1200);
            carousel.querySelectorAll('[data-preview-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(Number(thumb.dataset.previewThumb) === at)));
          };
          carousel.addEventListener('click', (event) => {
            const step = event.target.closest('[data-preview-step]');
            const thumb = event.target.closest('[data-preview-thumb]');
            if (step) go(at + Number(step.dataset.previewStep));
            else if (thumb) go(Number(thumb.dataset.previewThumb));
            else if (event.target === main && previewImages.length > 1) go(at + 1);
          });
        }
      } catch (error) {
        previewContent.innerHTML = '<div class="bedroom-builder__preview-copy"><p>Product details are unavailable right now. Please continue choosing from the builder.</p></div>';
      }
    };
    previewDialog?.addEventListener('click', (event) => {
      if (event.target === previewDialog) closeProductPreview();
    });
    const renderReview = () => {
      const review = builder.querySelector('[data-builder-review-list]');
      if (!review) return;
      review.innerHTML = state.items.length
        ? state.items.map((item, index) => `
          <div class="bedroom-builder__review-item">
            ${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : '<span aria-hidden="true"></span>'}
            <span><strong>${escapeHTML(item.title)}</strong><small>${escapeHTML(item.category)}${item.variantTitle ? ` - ${escapeHTML(item.variantTitle)}` : ''}</small></span>
            <button class="bedroom-builder__review-remove" type="button" data-builder-remove="${index}" aria-label="Remove ${escapeHTML(item.title)}">&times;</button>
          </div>`).join('')
        : '<p class="muted">Your selected pieces will appear here.</p>';
      const total = state.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
      const totalEl = builder.querySelector('[data-builder-review-total]');
      const countEl = builder.querySelector('[data-builder-review-count]');
      const sizeEl = builder.querySelector('[data-builder-review-size]');
      const addButton = builder.querySelector('[data-builder-add]');
      if (totalEl) totalEl.textContent = formatCartMoney(total, window.Shopify?.currency?.active || 'AUD');
      if (countEl) countEl.textContent = `${state.items.length} item${state.items.length === 1 ? '' : 's'}`;
      if (sizeEl) sizeEl.textContent = state.sizeLabel ? `${state.sizeLabel} selected` : 'No size selected';
      if (addButton) addButton.disabled = state.items.length === 0;
    };
    const revealProgressStep = (button, behavior = 'smooth') => {
      const scroller = builder.querySelector('[data-builder-progress-scroller]');
      if (!scroller || !button) return;
      const nextLeft = scroller.scrollLeft + button.getBoundingClientRect().left - scroller.getBoundingClientRect().left - (scroller.clientWidth - button.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, nextLeft), behavior });
    };
    // Each step's products come from the shop, already narrowed to the chosen size and to what is in stock, twelve at a time. (The twelve the page was
    // drawn with are only the first twelve of the whole collection, which may hold none in the size chosen.)
    const stepRequest = (panel, page) => {
      const base = panel.dataset.collectionUrl;
      if (!base) return null;
      const size = panel.hasAttribute('data-size-independent') ? '' : state.size;
      const path = size ? `${base}/size-${size}` : base;
      return `${path}?view=builder&filter.v.availability=1&page=${page}`;
    };
    const loadStep = async (panel, append = false) => {
      const products = panel.querySelector('[data-builder-products]');
      const index = Number(panel.dataset.builderPanel);
      const page = append ? Number(panel.dataset.nextPage || 2) : 1;
      const address = stepRequest(panel, page);
      if (!products || !address) return;
      const size = panel.hasAttribute('data-size-independent') ? '' : state.size;
      panel.dataset.loadedFor = size || '-';
      products.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(address, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Products unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...doc.querySelectorAll('[data-builder-item]')];
        const info = doc.querySelector('[data-builder-page-info]');
        cards.forEach((card) => { card.dataset.stepKey = String(index); if (panel.hasAttribute('data-size-independent')) card.dataset.sizeValues = '|all-sizes'; card.querySelectorAll('[id]').forEach((el) => { el.id = `${el.id}-${index}`; }); });
        if (!append) products.replaceChildren();
        cards.forEach((card) => products.appendChild(document.importNode(card, true)));
        panel.dataset.nextPage = String(page + 1);
        panel.querySelector('[data-builder-more]')?.toggleAttribute('hidden', info?.dataset.hasNext !== 'true');
        panel.dataset.total = info?.dataset.total || '';
      } catch (error) {
        panel.dataset.loadedFor = '';
      } finally {
        products.removeAttribute('aria-busy');
        updateBuilder();
      }
    };
    const ensureStepLoaded = (panel) => {
      if (!panel?.dataset.collectionUrl) return;
      const size = panel.hasAttribute('data-size-independent') ? '' : state.size;
      if (panel.dataset.loadedFor === (size || '-')) return;
      loadStep(panel);
    };
    const updateBuilder = (revealProgress = false) => {
      panels.forEach((panel, index) => {
        const isActive = index === activeStep;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) panel.setAttribute('tabindex', '-1'); else panel.removeAttribute('tabindex');
        const stepItems = panel.querySelectorAll('[data-builder-item]');
        const selectedCount = [...stepItems].filter((card) => selectedForCard(card)).length;
        panel.querySelector('[data-builder-step-count]')?.replaceChildren(document.createTextNode(`${selectedCount} added`));
      });
      progressButtons.forEach((button, index) => {
        if (index === activeStep) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
        button.classList.toggle('is-complete', index < activeStep);
      });
      if (revealProgress) revealProgressStep(progressButtons[activeStep]);
      const progressLabel = builder.querySelector('[data-builder-progress-label]');
      const activeStepLabel = progressButtons[activeStep]?.dataset.builderStepLabel || `Step ${activeStep + 1}`;
      if (progressLabel) progressLabel.textContent = `Step ${activeStep + 1} of ${panels.length} — ${activeStepLabel}`;
      const progressBar = builder.querySelector('[data-builder-progress-bar]');
      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', String(activeStep + 1));
        progressBar.style.setProperty('--builder-progress', `${((activeStep + 1) / panels.length) * 100}%`);
      }
      const sizeHint = builder.querySelector('[data-builder-size-hint]');
      if (sizeHint && state.sizeLabel) sizeHint.textContent = `${state.sizeLabel} selected. You can change it later.`;
      const sizeContinue = builder.querySelector('[data-builder-panel="0"] [data-builder-next]');
      if (sizeContinue) sizeContinue.disabled = !state.size;
      builder.querySelectorAll('[data-builder-size]').forEach((button) => button.classList.toggle('is-selected', button.dataset.sizeValue === state.size));
      builder.querySelectorAll('[data-builder-item]').forEach((card) => {
        const selected = selectedForCard(card);
        card.classList.toggle('is-selected', Boolean(selected));
        const button = card.querySelector('[data-builder-select]');
        if (button) {
          button.classList.toggle('is-selected', Boolean(selected));
          button.textContent = selected ? button.dataset.selectedText : button.dataset.selectText;
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }
        syncCardAvailability(card);
      });
      builder.querySelectorAll('[data-builder-products]').forEach((products) => {
        applyPanelFilters(products.closest('[data-builder-panel]'));
      });
      const selectionCount = builder.querySelector('[data-builder-selection-count]');
      if (selectionCount) selectionCount.textContent = `${state.items.length} item${state.items.length === 1 ? '' : 's'} selected`;
      renderReview();
      saveState();
      ensureStepLoaded(panels[activeStep]);
    };
    const moveTo = (step) => {
      activeStep = Math.max(0, Math.min(step, panels.length - 1));
      updateBuilder(true);
      panels[activeStep]?.focus({ preventScroll: true });
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    builder.addEventListener('click', async (event) => {
      const size = event.target.closest('[data-builder-size]');
      const select = event.target.closest('[data-builder-select]');
      const next = event.target.closest('[data-builder-next]');
      const skip = event.target.closest('[data-builder-skip]');
      const back = event.target.closest('[data-builder-back]');
      const progress = event.target.closest('[data-builder-progress-step]');
      const remove = event.target.closest('[data-builder-remove]');
      const reset = event.target.closest('[data-builder-reset]');
      const add = event.target.closest('[data-builder-add]');
      const preview = event.target.closest('[data-builder-preview]');
      const previewClose = event.target.closest('[data-builder-preview-close]');
      const previewChoose = event.target.closest('[data-builder-preview-choose]');
      const loadMore = event.target.closest('[data-builder-load-more]');
      const clearFilters = event.target.closest('[data-builder-clear-filters]');

      if (clearFilters) {
        const panelToClear = clearFilters.closest('[data-builder-panel]');
        panelToClear.querySelectorAll('[data-builder-filter]').forEach((control) => { control.value = ''; });
        applyPanelFilters(panelToClear);
        return;
      }
      if (loadMore) {
        event.preventDefault();
        loadStep(loadMore.closest('[data-builder-panel]'), true);
        return;
      }
      if (preview) {
        event.preventDefault();
        openProductPreview(preview.closest('[data-builder-item]'));
        return;
      }
      if (previewClose) {
        event.preventDefault();
        closeProductPreview();
        return;
      }
      if (previewChoose) {
        event.preventDefault();
        const productId = previewChoose.dataset.previewProductId;
        closeProductPreview();
        const productCard = builder.querySelector(`[data-builder-panel="${activeStep}"] [data-builder-item][data-product-id="${CSS.escape(productId)}"]`);
        productCard?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        (productCard?.querySelector('select[data-builder-variant], [data-builder-select]'))?.focus({ preventScroll: true });
        return;
      }

      if (size) {
        event.preventDefault();
        state.size = size.dataset.sizeValue || '';
        state.sizeLabel = size.dataset.sizeLabel || '';
        state.items = state.items.filter((item) => {
          const card = builder.querySelector(`[data-builder-item][data-product-id="${CSS.escape(item.productId)}"]`);
          return !card || visibleForSize(card);
        });
        emit('bedroom_builder_size_selected', { bedroom_size: state.sizeLabel });
        updateBuilder();
      }
      if (select && !select.disabled) {
        event.preventDefault();
        const card = select.closest('[data-builder-item]');
        const selected = selectedForCard(card);
        if (selected && selected.variantId === currentVariant(card)) {
          state.items = state.items.filter((item) => item.cardKey !== cardKey(card));
        } else {
          const option = variantOption(card);
          const nextItem = {
            cardKey: cardKey(card), productId: card.dataset.productId, variantId: currentVariant(card),
            title: card.dataset.productTitle, category: card.closest('[data-builder-panel]')?.querySelector('h3')?.textContent || 'Bedroom set',
            variantTitle: option?.textContent.trim() || '', price: currentVariantPrice(card), image: card.dataset.productImage || ''
          };
          state.items = [...state.items.filter((item) => item.cardKey !== cardKey(card)), nextItem];
          emit('bedroom_builder_item_selected', { item_name: nextItem.title, bedroom_size: state.sizeLabel });
        }
        updateBuilder();
      }
      if (next) {
        event.preventDefault();
        moveTo(activeStep + 1);
      }
      if (skip) { event.preventDefault(); emit('bedroom_builder_skipped', { step: activeStep + 1 }); moveTo(activeStep + 1); }
      if (back) { event.preventDefault(); moveTo(activeStep - 1); }
      if (progress) { event.preventDefault(); moveTo(Number(progress.dataset.builderProgressStep)); }
      if (remove) { event.preventDefault(); state.items.splice(Number(remove.dataset.builderRemove), 1); updateBuilder(); }
      if (reset) {
        event.preventDefault(); state = { ...defaultState }; activeStep = 0; updateBuilder(); moveTo(0);
      }
      if (add) {
        event.preventDefault();
        if (!state.items.length) return;
        add.disabled = true; add.setAttribute('aria-busy', 'true');
        const error = builder.querySelector('[data-builder-error]'); error?.setAttribute('hidden', '');
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: state.items.map((item) => ({ id: item.variantId, quantity: 1, properties: { 'Bedroom size': state.sizeLabel || 'Not specified', 'Bedroom builder': 'Build your bedroom set' } })) })
          });
          if (!response.ok) throw new Error('Cart add failed');
          emit('bedroom_builder_add_to_cart', { item_count: state.items.length, bedroom_size: state.sizeLabel });
          await refreshCartDrawer();
          const drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) { drawer.setAttribute('open', ''); document.body.classList.add('drawer-open'); }
          state = { ...defaultState }; saveState(); updateBuilder();
        } catch (error) {
          const errorMessage = builder.querySelector('[data-builder-error]');
          errorMessage?.replaceChildren(document.createTextNode("We couldn't add the set right now. Please try again."));
          errorMessage?.removeAttribute('hidden'); add.disabled = false;
        } finally { add.removeAttribute('aria-busy'); }
      }
    });
    builder.addEventListener('change', (event) => {
      if (event.target.matches('[data-builder-variant]')) {
        const card = event.target.closest('[data-builder-item]');
        state.items = state.items.filter((item) => item.cardKey !== cardKey(card));
        card.dataset.productPrice = currentVariantPrice(card);
        updateBuilder();
        return;
      }
      if (event.target.closest('[data-builder-toolbar]')) {
        emit('bedroom_builder_filter', { filter_name: event.target.dataset.builderFilter || 'sort', filter_value: event.target.value });
        updateBuilder();
      }
    });
    builder.addEventListener('input', (event) => {
      if (!event.target.closest('[data-builder-toolbar]')) return;
      updateBuilder();
    });
    builder.addEventListener('focusin', (event) => {
      const progressButton = event.target.closest('[data-builder-progress-step]');
      if (progressButton) revealProgressStep(progressButton, 'auto');
    });
    updateBuilder(true);
  });

  const loadCrossSellRecommendations = (scope = document) => {
    scope.querySelectorAll('[data-cross-sell-root][data-cross-sell-url]').forEach(async (placeholder) => {
      if (placeholder.dataset.crossSellLoading === 'true') return;
      placeholder.dataset.crossSellLoading = 'true';
      try {
        const response = await fetch(placeholder.dataset.crossSellUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error(`Recommendation request failed with ${response.status}`);
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = documentFragment.querySelector(`[data-cross-sell-section="${CSS.escape(placeholder.dataset.crossSellSection)}"]`);
        if (!replacement || replacement.dataset.crossSellUrl) return;
        placeholder.replaceWith(replacement);
        syncWishlistControls();
        document.dispatchEvent(new CustomEvent('slumbery:products:updated'));
      } catch (_error) {
        placeholder.removeAttribute('data-cross-sell-loading');
      }
    });
  };

  loadCrossSellRecommendations();
  document.addEventListener('shopify:section:load', (event) => loadCrossSellRecommendations(event.target));

  const initialiseFooter = (scope = document) => {
    const mobileFooter = window.matchMedia('(max-width: 899px)');
    scope.querySelectorAll('[data-footer-disclosure]').forEach((disclosure) => {
      if (disclosure.dataset.footerInitialised === 'true') return;
      disclosure.dataset.footerInitialised = 'true';
      const updateDisclosure = (event) => {
        if (event.matches) disclosure.removeAttribute('open');
        else disclosure.setAttribute('open', '');
      };
      updateDisclosure(mobileFooter);
      mobileFooter.addEventListener('change', updateDisclosure);
    });

    scope.querySelectorAll('.footer-newsletter__form').forEach((form) => {
      if (form.dataset.newsletterInitialised === 'true') return;
      form.dataset.newsletterInitialised = 'true';
      const email = form.querySelector('[data-newsletter-email]');
      const status = form.querySelector('[data-newsletter-status]');
      const submit = form.querySelector('[data-newsletter-submit]');
      email?.addEventListener('invalid', () => {
        email.setAttribute('aria-invalid', 'true');
        if (status) status.textContent = email.dataset.invalidMessage || 'Enter a valid email address.';
      });
      email?.addEventListener('input', () => {
        email.removeAttribute('aria-invalid');
        if (status) status.textContent = '';
      });
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        if (form.dataset.submitting === 'true') {
          event.preventDefault();
          return;
        }
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.submittingLabel || 'Subscribing…';
        }
      });
      form.querySelector('.form-message--success')?.focus();
    });
  };

  const initialiseFaqAccordions = (scope = document) => {
    scope.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
      if (accordion.dataset.faqInitialised === 'true') return;
      accordion.dataset.faqInitialised = 'true';
      const summary = accordion.querySelector('summary');
      if (!summary) return;
      const updateExpandedState = () => summary.setAttribute('aria-expanded', String(accordion.open));
      updateExpandedState();
      accordion.addEventListener('toggle', updateExpandedState);
    });
  };

  const initialiseBedFinderQuiz = (scope = document) => {
    scope.querySelectorAll('[data-bed-finder-quiz]').forEach((quiz) => {
      if (quiz.dataset.quizInitialised === 'true') return;
      quiz.dataset.quizInitialised = 'true';

      let quizConfig = {};
      let firmnessConfig = {};
      try { quizConfig = JSON.parse(quiz.dataset.quizConfig || '{}'); } catch (error) { quizConfig = {}; }
      try { firmnessConfig = JSON.parse(quiz.dataset.firmnessConfig || '{}'); } catch (error) { firmnessConfig = {}; }
      const builderUrl = quiz.dataset.builderUrl || '';

      const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
      const result = quiz.querySelector('[data-quiz-result]');
      const answers = {};

      const showStep = (index) => {
        steps.forEach((step) => { step.hidden = Number(step.dataset.quizStep) !== index; });
        if (result) result.hidden = true;
      };

      const showResult = () => {
        steps.forEach((step) => { step.hidden = true; });
        if (!result) return;
        result.hidden = false;

        const sizeInfo = quizConfig[answers.sleepers] || {};
        const firmnessUrl = firmnessConfig[answers.firmness] || '';

        const sizeEl = result.querySelector('[data-quiz-result-size]');
        const firmnessEl = result.querySelector('[data-quiz-result-firmness]');
        if (sizeEl) sizeEl.textContent = sizeInfo.label || 'bed';
        if (firmnessEl) firmnessEl.textContent = answers.firmness || '';

        const mattressLink = result.querySelector('[data-quiz-result-mattress-link]');
        if (mattressLink) {
          const href = firmnessUrl || sizeInfo.url || '';
          if (href) {
            mattressLink.href = href;
            mattressLink.hidden = false;
          } else {
            mattressLink.hidden = true;
          }
        }

        const builderLink = result.querySelector('[data-quiz-result-builder-link]');
        if (builderLink) {
          if (builderUrl && sizeInfo.handle) {
            const separator = builderUrl.includes('?') ? '&' : '?';
            builderLink.href = `${builderUrl}${separator}size=${encodeURIComponent(sizeInfo.handle)}&bedroom-builder=1`;
            builderLink.hidden = false;
          } else {
            builderLink.hidden = true;
          }
        }
      };

      quiz.addEventListener('click', (event) => {
        const answerButton = event.target.closest('[data-quiz-answer]');
        if (answerButton) {
          const question = answerButton.dataset.quizQuestion;
          const value = answerButton.dataset.quizValue;
          answers[question] = value;
          if (question === 'sleepers') {
            showStep(1);
          } else if (question === 'firmness') {
            showResult();
          }
          return;
        }
        if (event.target.closest('[data-quiz-restart]')) {
          Object.keys(answers).forEach((key) => delete answers[key]);
          showStep(0);
        }
      });

      showStep(0);
    });
  };

  document.addEventListener('slumbery:products:updated', syncWishlistControls);
  initialiseFooter();
  initialiseFaqAccordions();
  initialiseBedFinderQuiz();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFooter(event.target);
    initialiseFaqAccordions(event.target);
    initialiseBedFinderQuiz(event.target);
  });
})();


/* Phones: the search icon in the header opens and closes the search box under it. */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-search-toggle]');
  if (!toggle) return;
  const header = toggle.closest('.site-header');
  const open = header.classList.toggle('is-search-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) header.querySelector('.mobile-search input[type="search"]')?.focus();
});


/* Product page: a typed quantity above what is in stock drops to the stock level. */
document.addEventListener('change', (event) => {
  const input = event.target.closest?.('[data-product-quantity-input]');
  if (!input) return;
  const max = Number(input.max);
  const value = Number.parseInt(input.value, 10);
  if (!Number.isFinite(value) || value < 1) input.value = '1';
  else if (max > 0 && value > max) input.value = String(max);
});


/* Tabbed shelves: choosing a tab shows its products and hides the others; the rails are told to measure again because a hidden rail has no width. */
document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-tab]');
  if (!tab) return;
  const shelf = tab.closest('[data-tabbed-shelf]');
  const tabs = [...shelf.querySelectorAll('[data-tab]')];
  const panels = [...shelf.querySelectorAll('[data-tab-panel]')];
  const index = tabs.indexOf(tab);
  tabs.forEach((t, i) => t.setAttribute('aria-selected', String(i === index)));
  panels.forEach((panel, i) => { panel.hidden = i !== index; });
  window.dispatchEvent(new Event('resize'));
});
